import { CompanyTableInfo } from '@aibees/elephant/feature/search-table-company';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { UserRelation } from '@aibees/shared/definition';
import { useMemo } from 'react';
import { SearchType } from '../../types';
import { useOwnerData } from './use-owner-data';

interface UseCurrentOwnerParams {
  selectedUser?: UserRelation;
  item?: CompanyTableInfo | PeopleTableInfo;
  searchTypeOverride?: SearchType;
}

export function useCurrentOwner({
  selectedUser: propsSelectedUser,
  item,
  searchTypeOverride,
}: UseCurrentOwnerParams) {
  const ownerData = useOwnerData(searchTypeOverride);

  return useMemo(() => {
    return propsSelectedUser || item?.user || ownerData;
  }, [propsSelectedUser, item?.user, ownerData]);
}
